import {StatLogger} from 'OK/StatLogger';

export class LogContentReco {
    private statLogger!: StatLogger;

    activate(el: HTMLElement) {
        const typeAttrs = el.getAttribute("data-layer-type");
        this.statLogger = new StatLogger('layer.recommendations.block.');
        if (typeAttrs) {
            this.statLogger.success(typeAttrs);
        }
    }

    deactivate() {}
}
